<script>
    import { mapActions,mapState } from 'vuex';

    export default {
        data () {
            return {

            }
        },
        computed: {
            ...mapState([
                'classSelectors',
            ]),
            ...mapState('sections',[
                'sectionStates',
                'sectionCategoryMapping',
                'sectionManagerInitFlag',
                'sectionManagerWrapper',
                'registeredSections'
            ]),
        },
        methods: {
            ...mapActions('sections',[
                'registerSection',
                'setSectionManagerInitFlag'
            ]),
            parseSectionsWrapper () {

                let sectionsNodeList = this.sectionManagerWrapper.querySelectorAll("." + this.classSelectors.sectionNode);

                //also include the sectionManagerWrapper in case its a section it self
                if (this.sectionManagerWrapper.classList.contains(this.classSelectors.sectionNode)) {
                    this.initSection(this.sectionManagerWrapper);
                }

                for (let index in sectionsNodeList) {

                    if (!sectionsNodeList.hasOwnProperty(index)) {
                        continue;
                    }

                    this.initSection(sectionsNodeList[index]);
                }

            },
            initSection (sectionNode) {
                let sectionId = sectionNode.getAttribute("id");
                let sectionTemplateId = sectionNode.getAttribute("data-section-id");
                let sameIdFound = false;
                let registrationData = {};


                if (sectionId) {
                    this.registeredSections.map ( sectionData => {
                        if (sectionData.sectionId === sectionId) {
                            sameIdFound = true;
                        }
                    });

                    //skip already registered sections
                    if (sameIdFound) {
                        return;
                    } else {
                        registrationData["sectionId"] = sectionId;
                    }
                } else {
                    registrationData["tempId"] = window.createTimeID(); //create a temp ID until a section class is initialised which in turn will overwrite the tempId
                }

                if (sectionTemplateId) {
                    registrationData["sectionTemplateId"] = sectionTemplateId; // if it doesnt exist create a basic html section class
                }

                registrationData["sectionNode"] = sectionNode; // also pass the node so we dont have to querySelector again inside the section class
                this.registerSection(registrationData);

            },
            sectionsWrapperParsedCallback () {

            },
        },
        watch : {
            sectionManagerInitFlag:  {
                immediate: true,
                handler () {
                    if (this.sectionManagerInitFlag) {
                        this.parseSectionsWrapper();
                        this.sectionsWrapperParsedCallback();
                        this.setSectionManagerInitFlag(false);

                    }
                }
            },
        },
    }

</script>
